import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  PaxsGroup: {},
  DataPaxLeader: {},
  PassengerService: {}
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
